import { render, staticRenderFns } from "./UnsubscribeComponent.vue?vue&type=template&id=7f24d35a&scoped=true&"
import script from "./UnsubscribeComponent.vue?vue&type=script&lang=js&"
export * from "./UnsubscribeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f24d35a",
  null
  
)

export default component.exports